import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/**
 * דשבורד ההנהלה (PRD 5.12).
 *
 * RPC אחת, כי הדשבורד נפתח פעם אחת ומראה הכל. כל מספר הוא "מה דורש
 * טיפול" ולא "כמה יש": מנהל לא צריך לדעת שיש ארבעים לומדות, אלא
 * שארבע מהן באיחור.
 */

export type Dashboard = {
  branches: { id: string; name: string }[];
  missing_constraints: {
    count: number;
    deadline: string | null;
    employees: { employee_id: string; name: string }[];
  };
  understaffed: {
    count: number;
    shifts: { date: string; shift: string; required: number; assigned: number }[];
  };
  ack_messages: {
    message_id: string;
    body: string;
    created_at: string;
    acked: number;
    audience: number;
  }[];
  late_learning: {
    assignment_id: string;
    title: string;
    due_date: string;
    pending: number;
  }[];
  checklists: {
    template_id: string;
    template: string;
    branch_id: string;
    branch: string;
    run_id: string | null;
    completed_at: string | null;
    total: number;
    done: number;
  }[];
  pending_requests: {
    request_id: string;
    name: string;
    type: string;
    created_at: string;
  }[];
  leaderboard: { employee_id: string; name: string; points: number }[];
};

export function useDashboard(branchId: string | null) {
  return useQuery({
    queryKey: ['dashboard', branchId ?? 'all'],
    queryFn: async (): Promise<Dashboard | null> => {
      const { data, error } = await supabase.rpc('dashboard', {
        p_branch: branchId ?? undefined,
      });
      if (error) throw error;
      return data as Dashboard | null;
    },
    staleTime: 60 * 1000,
  });
}

/** אחוז, מעוגל, בלי חלוקה באפס. */
export function percent(part: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((part / total) * 100);
}
